import {
  CloseButton,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";
import Searchicon from "assets/svg/search-icon.svg";
import React from "react";
import { CiSearch } from "react-icons/ci";
import { set } from "rsuite/esm/internals/utils/date";
const InputTextSearchBox = ({
  filterData,
  inputState,
  fieldName,
  setInputState,
  setActiveField,
  activeFieldName,
  isFilterActiveState,
  inputPlaceholder,
  isDisabled,
}) => {
  const [inputValue, setInputValue] = React.useState(inputState);
  const toSetFilter =()=>{
    setInputState(inputValue.trim());
    setActiveField({
      name: activeFieldName,
      value: inputValue.trim(),
    });
    filterData(inputValue.trim(), fieldName);
  }
  return (
    <React.Fragment>
      <div style={{ width: "200px" }}>
        <InputGroup>
          <InputLeftElement
          // children={
          //   <img
          //     src={Searchicon}
          //     width="18px"
          //     height="18px"
          //     style={{ cursor: "pointer" }}
          //   />
          // }
          // onClick={() => {
          //   filterData(inputState, fieldName);
          // }}
          >
            <IconButton
              disabled={!inputValue}
              _hover={{ background: "transparent" }}
              background={"transparent"}
              _focus={{ outline: "none" }}
              onClick={toSetFilter}
            >
              <CiSearch style={{ fontSize: "1.2rem" }} />
            </IconButton>
          </InputLeftElement>
          <Input
            type="text"
            id={activeFieldName == "skill" ? "skill-1" : activeFieldName}
            value={inputValue}
            placeholder={inputPlaceholder}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                toSetFilter();
              }
            }}
            style={{
              height: "37px",
              padding: "9px",
              paddingLeft: "2.6rem",
              paddingRight: !isFilterActiveState ? "1rem" : "2.3rem",
              color: "#7B9AAA",
              fontFamily: "Roboto",
              fontWeight: "500",
              lineHeight: "19px",
              fontSize: "15px",
            }}
          />
          {isFilterActiveState && (
            <InputRightElement style={{ height: "2.3rem" }}>
              <CloseButton
                size="sm"
                onClick={() => {
                  filterData("", fieldName);
                  setInputState("");
                  setInputValue("");
                  setActiveField({
                    name: activeFieldName,
                    value: "",
                  });
                }}
                _focus={{ boxShadow: "none" }}
              />
            </InputRightElement>
          )}
        </InputGroup>
      </div>
    </React.Fragment>
  );
};

export default InputTextSearchBox;
